module.exports = __webpack_public_path__ + "static/media/mbr-1-1920x1210.071d610a.jpg";